import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import accountReducer from './reducers/accountReducer'
import uxReducer from './reducers/uxReducer';
import categoryReducer from './reducers/categoryReducer';
import projectReducer from './reducers/projectReducer';
import skillReducer from './reducers/skillReducer';
import industryReducer from './reducers/industryReducer';
import jobReducer from './reducers/jobReducer';
import faqReducer from './reducers/faqReducer';
import policiesReducer from './reducers/policiesReducer';

const rootReducer = combineReducers({
  accountReducer,
  uxReducer,
  categoryReducer,
  projectReducer,
  skillReducer,
  industryReducer,
  jobReducer,
  faqReducer,
  policiesReducer
})

let store = createStore(rootReducer, applyMiddleware(thunk));

export default store
